<template>
  <v-dialog v-model="opened">
    <v-card class="basic-modal" elevation="4">
      <v-card-title class="d-flex justify-space-between">
        <h6 class="heading--text d-flex align-center">
          <span> {{ $t("reseller.emailSettings.sendTestEmail") }}</span>
        </h6>
        <v-btn v-if="!submitting" icon x-small @click="close()">
          <v-icon size="24">$close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-6 py-5">
        <v-row gutters class="align-center">
          <v-col cols="4">
            <span>{{
              $t("reseller.emailSettings.sendTestEmailToAddress")
            }}</span>
          </v-col>
          <v-col cols="8">
            <v-text-field v-model="email" outlined hide-details></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="d-flex flex-wrap pb-4">
        <div class="w-100 pb-2">
          <v-btn
            :text="false"
            large
            block
            elevation="0"
            class="primary"
            @click="submit()"
            :loading="submitting"
          >
            <span class="p-2 font-weight-600">{{
              $t("button.sendTestEmail")
            }}</span>
          </v-btn>
        </div>
        <div class="w-100 pb-2 cancel-btn">
          <v-btn
            :text="true"
            large
            block
            elevation="0"
            class="normal"
            @click="!submitting && close()"
          >
            <span class="p-2 font-weight-bold gray--text text--darken-1">
              {{ $t("button.cancel") }}
            </span>
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Api from "../../apis/Api";

export default {
  components: {},
  props: {
    settings: Object,
  },
  data() {
    return {
      opened: false,
      submitting: false,
      email: "",
    };
  },
  methods: {
    open() {
      if (this.email == "") {
        this.email = this.$store.state.home.user.email;
      }
      this.opened = true;
    },
    close() {
      this.opened = false;
    },
    submit() {
      this.submitting = true;
      Api.post(`/reseller/email-settings/send-test-email`, {
        ...this.settings,
        to_email: this.email,
      })
        .then(() => {
          this.$store.dispatch("addAlert", {
            success: true,
            successMessage: this.$t("message.alertManager.success"),
          });
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
  watch: {
    // opened(opened) {
    //   if (opened) {
    //     this.$store.dispatch("lockBodyScroll");
    //     return;
    //   }
    //   this.$store.dispatch("unlockBodyScroll");
    // },
  },
};
</script>

<style src="@/components/modal/BasicModal.scss" lang="scss" scoped/>
